import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { DirectoryState } from '../../../../../../core/stores/directory/directory.reducer';
import { selectDirectorySkills } from '../../../../../../core/stores/directory/directory.selectors';
import { FilterService } from '../../../../services/filter.service';
import { SpotlightProfilesState } from '../../../../store/spotlight-profiles/spotlight-profiles.reducer';
import { selectSpotlightProfilesFiltersSkills } from '../../../../store/spotlight-profiles/spotlight-profiles.selectors';

@Component({
  selector: 'sl-profile-list-skill-filter',
  templateUrl: './profile-list-skill-filter.component.html',
  styleUrls: ['./profile-list-skill-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileListSkillFilterComponent {
  skills$ = this._directoryStore.select(selectDirectorySkills);
  selectedSkills$ = this._spotlightProfileStore.select(selectSpotlightProfilesFiltersSkills);

  constructor(
    private readonly _spotlightProfileStore: Store<SpotlightProfilesState>,
    private readonly _directoryStore: Store<DirectoryState>,
    private readonly _filter: FilterService,
  ) {}

  onSelectedSkillsChange(skills: AccredibleObjectWithId[]): void {
    this._filter.updateRouterQueryParams({ skills: skills.map((skill) => skill.id) });
  }
}
